import React from "react";

export default function SidebarLoadingIcon({
  style = {},
  isAbsolute = false,
  ...props
}) {
  const defaultStyle = { width: 20 };
  if (isAbsolute) {
    defaultStyle.position = "absolute";
    defaultStyle.top = "50%";
    defaultStyle.left = "50%";
    defaultStyle.transform = "translate(-50%, -50%)";
  }
  return (
    <img
      src={require("assets/img/sidebarLoading.gif")}
      alt="Loading"
      style={{ ...defaultStyle, ...style }}
      {...props}
    />
  );
}
